export default function DownloadAppAndroidIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 209 209"
    >
      <path d="M108.08,104.51L28.89,183.36c-.59-1.57-.92-3.49-.92-5.83V30.76c0-2,.24-3.69.68-5.09l79.43,78.84Z"/>
      <path d="M137.74,74.97l-23.99,23.89L34.19,19.89c3.41-1.02,7.52-.01,10.38,1.58l93.17,53.5Z"/>
      <path d="M138.8,135l-94.23,53.15c-2.83,1.26-6.69,1.9-9.98.83l79.17-78.83,25.04,24.85Z"/>
      <path d="M174.07,115.1l-28.03,15.81-26.61-26.41,25.5-25.39,29.14,16.73c9.29,5.32,9.29,13.95,0,19.26Z"/>
    </svg>
  );
}
